import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import Carousel from 'react-bootstrap/lib/Carousel';
import Modal from 'react-bootstrap/lib/Modal';

class PowerpointPreview extends React.Component {
  constructor(props) {
    super(props);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.state = {
      indexSelected: 0,
      direction: null,
      show: false,
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  onSelect(selectedIndex, e) {
    this.setState({
      indexSelected: selectedIndex,
      direction: e.direction,
    });
  }

  render() {
    const { powerPoint } = this.props;

    return (
      <div className="powerpoint-preview">
        <div className="powerpoint-wrapper">
          <div className="powerpoint-pagination">
            <div
              className="powerpoint-pagination-item-wrapper"
              onClick={this.handleShow}
            >
              <div className="powerpoint-pagination-item">
                <img className="img-responsive" src={powerPoint.summary} />
              </div>
              <div className="powerpoint-pagination-hover">
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  style={{ width: '1em' }}
                />
              </div>
            </div>
          </div>
          {powerPoint.previews.length < 1 ? (
            <Modal show={this.state.show} onHide={this.handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Modal heading</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h4>Not found!</h4>
              </Modal.Body>
            </Modal>
          ) : (
            <Modal
              className="modal-powerpoint-row"
              bsSize="large"
              show={this.state.show}
              onHide={this.handleClose.bind(this)}
            >
              <Modal.Header closeButton>
                <Modal.Title />
              </Modal.Header>
              <Modal.Body>
                <div className="modal-powerpoint">
                  <Carousel
                    onSelect={this.onSelect}
                    activeIndex={this.state.indexSelected}
                  >
                    {powerPoint.previews.map((item, key) => (
                      <Carousel.Item key={key}>
                        <img
                          width="100%"
                          height={720}
                          className="img-responsive"
                          src={`${item}`}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                  <small style={{ color: 'rgb(226, 216, 216)' }}>
                    {this.state.indexSelected + 1} of{' '}
                    {powerPoint.previews.length}
                  </small>
                </div>
              </Modal.Body>
            </Modal>
          )}
        </div>
        <style jsx global>
          {`
            .powerpoint-preview .powerpoint-wrapper {
              display: flex;
              flex-wrap: wrap;
              background-color: #ffffff;
            }
            .powerpoint-preview .powerpoint-wrapper .powerpoint-pagination {
              width: 100%;
            }
            .powerpoint-preview
              .powerpoint-wrapper
              .powerpoint-pagination
              .powerpoint-pagination-item-wrapper {
              position: relative;
            }
            .powerpoint-preview
              .powerpoint-wrapper
              .powerpoint-pagination
              .powerpoint-pagination-item-wrapper:hover
              .powerpoint-pagination-hover {
              display: flex !important;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            }
            .powerpoint-preview
              .powerpoint-wrapper
              .powerpoint-pagination
              .powerpoint-pagination-hover {
              display: none;
              position: absolute;
              top: 0;
              width: 100%;
              height: 100%;
              color: #fff;
              font-size: 35px;
              cursor: pointer;
              background-color: rgba(29, 29, 29, 0.5);
            }
            .powerpoint-preview
              .powerpoint-wrapper
              .powerpoint-pagination
              .powerpoint-pagination-item {
              border: 1px solid rgba(0, 0, 0, 0.1);
              min-height: 180px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            }

            .modal-header .close {
              margin-top: -2px;
              margin-bottom: -25px;
              opacity: 0.7;
              color: white;
              font-size: 35px;
            }

            .modal-powerpoint {
              text-align: -webkit-center;
            }

            .modal-powerpoint-row .modal-dialog .modal-content {
              background-color: transparent;
            }

            @media (min-width: 1280px) {
              .modal-powerpoint-row .modal-dialog {
                width: 1280px !important;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

PowerpointPreview.propTypes = {
  summary: PropTypes.object,
  previews: PropTypes.array,
  powerPoint: PropTypes.object,
};

PowerpointPreview.defaultProps = {
  powerPoint: {
    thumbnail:
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_0.jpeg',
    summary:
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_1.jpeg',
    previews: [
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_2.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_3.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_4.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_5.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_6.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_7.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_8.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_9.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_10.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_11.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_12.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_13.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_14.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_15.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_16.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_17.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_18.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_19.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_20.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_21.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_22.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_23.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_24.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_25.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_26.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_27.jpeg',
      'https://data.designac.co/data/thumbnails/0c/0cc9695e067bf42c291d2873b210e57a_28.jpeg',
    ],
  },
};

export default PowerpointPreview;
